module.exports = __webpack_public_path__ + "img/lock-password.4e6e4669.svg";